<template>
  <div>
    <div class="container">
      <!-- 5 columns on large screens, fewer on smaller -->
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 pt-5">
        <div v-for="(item, idx) in data" :key="idx" class="col mb-3">
          <footer-data :data="item" />
        </div>
      </div>
      <hr />
      <div class="row">
        <p class="text-center">
          {{ $t('sistemi_prokurorial.footer.copyright.title') }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import footerData from '../share/FooterFill.vue'

export default {
    data(){
        return{
            subdomain:'',
            data:[]
        }
    },
    components:{
        footerData
    },
    methods:{
        getSubdomain() {
            const host = window.location.hostname;
            this.subdomain = '';
            if (host.includes('.')) {
                this.subdomain = host.split('.')[0];
            }
        },
        getDataForSubdomain(sub) {
        const allData = {
            localhost: [
                    {
                        titulli:this.$te('sistemi_prokurorial.footer.address.title') ? this.$t('sistemi_prokurorial.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('sistemi_prokurorial.footer.address.address_content') ? this.$t('sistemi_prokurorial.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('sistemi_prokurorial.footer.contact.title') ? this.$t('sistemi_prokurorial.footer.contact.title') : null,
                        ikona1:"envelope",
                        ikona2:"phone-volume",
                        tekst1:"ZKPSH: +383 (0) 38 200 66920",
                        tekst2:"KPK: +383 (0) 38 200 17 473",
                    },
                    {
                        titulli:this.$te('sistemi_prokurorial.footer.email.title') ? this.$t('sistemi_prokurorial.footer.email.title') : null,
                        ikona1:"envelope",
                        ikona2:"envelope",
                        tekst1:"info.psh@rks-psh.org",
                        tekst2:"info.kpk@rks-psh.org",
                    },
                     {
                        titulli:this.$te('sistemi_prokurorial.footer.social_media.title') ? this.$t('sistemi_prokurorial.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('sistemi_prokurorial.footer.social_media.link') ? this.$t('sistemi_prokurorial.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('sistemi_prokurorial.footer.social_media.link2') ? this.$t('sistemi_prokurorial.footer.social_media.link2') : null,
                    }
            ],
            default: [
                    {
                        titulli:this.$te('sistemi_prokurorial.footer.address.title') ? this.$t('sistemi_prokurorial.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('sistemi_prokurorial.footer.address.address_content') ? this.$t('sistemi_prokurorial.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('sistemi_prokurorial.footer.contact.title') ? this.$t('sistemi_prokurorial.footer.contact.title') : null,
                        ikona1:"envelope",
                        ikona2:"phone-volume",
                        tekst1:"ZKPSH: +383 (0) 38 200 66920",
                        tekst2:"KPK: +383 (0) 38 200 17 473",
                    },
                    {
                        titulli:this.$te('sistemi_prokurorial.footer.email.title') ? this.$t('sistemi_prokurorial.footer.email.title') : null,
                        ikona1:"envelope",
                        ikona2:"envelope",
                        tekst1:"info.psh@rks-psh.org",
                        tekst2:"info.kpk@rks-psh.org",
                    },
                    {
                        titulli:this.$te('sistemi_prokurorial.footer.magazine.title') ? this.$t('sistemi_prokurorial.footer.magazine.title') : null,
                        ikona_read:"link",
                        read:this.$te('sistemi_prokurorial.footer.magazine.read') ? this.$t('sistemi_prokurorial.footer.magazine.read') : null,
                        link:this.$te('sistemi_prokurorial.footer.magazine.link') ? this.$t('sistemi_prokurorial.footer.magazine.link') : null,
                    },
                    {
                        titulli:this.$te('sistemi_prokurorial.footer.social_media.title') ? this.$t('sistemi_prokurorial.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('sistemi_prokurorial.footer.social_media.link') ? this.$t('sistemi_prokurorial.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('sistemi_prokurorial.footer.social_media.link2') ? this.$t('sistemi_prokurorial.footer.social_media.link2') : null,
                    }
            ],
            kpk: [
                {
                        titulli:this.$te('menus.kpk.footer.address.title') ? this.$t('menus.kpk.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('menus.kpk.footer.address.address_content') ? this.$t('menus.kpk.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.contact.title') ? this.$t('menus.kpk.footer.contact.title') : null,
                        ikona1:"envelope",
                        ikona2:"phone-volume",
                        // tekst1:"ZKPSH: +383 (0) 38 200 66920",
                        tekst2:"KPK: +383 (0) 38 200 17 473",
                        // tekst3:"+383 (0) 38 200 17 473",
                        tekst3_title:this.$te('menus.kpk.footer.contact.reception') ? this.$t('menus.kpk.footer.contact.reception') : null
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.email.title') ? this.$t('menus.kpk.footer.email.title') : null,
                        ikona1:"envelope",
                        ikona2:"envelope",
                        tekst1:"info.kpk@rks-psh.org",
                        // tekst2:"info.kpk@rks-psh.org",
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.magazine.title') ? this.$t('menus.kpk.footer.magazine.title') : null,
                        ikona_read:"link",
                        read:this.$te('menus.kpk.footer.magazine.read') ? this.$t('menus.kpk.footer.magazine.read') : null,
                        link:this.$te('menus.kpk.footer.magazine.link') ? this.$t('menus.kpk.footer.magazine.link') : null,
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.social_media.title') ? this.$t('menus.kpk.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('menus.kpk.footer.social_media.link') ? this.$t('menus.kpk.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('menus.kpk.footer.social_media.link2') ? this.$t('menus.kpk.footer.social_media.link2') : null,
                    }
            ],
            sekretariati: [
                    {
                        titulli:this.$te('menu.kpk.footer.address.title') ? this.$t('menus.kpk.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('menus.kpk.footer.address.address_content') ? this.$t('menus.kpk.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.contact.title') ? this.$t('menus.kpk.footer.contact.title') : null,
                        ikona1:"envelope",
                        ikona2:"phone-volume",
                        tekst1:"ZKPSH: +383 (0) 38 200 66920",
                        tekst2:"KPK: +383 (0) 38 200 17 473",
                        tekst3:"+383 (0) 38 200 17 473",
                        tekst3_title:this.$te('menus.kpk.footer.contact.reception') ? this.$t('menus.kpk.footer.contact.reception') : null
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.email.title') ? this.$t('menus.kpk.footer.email.title') : null,
                        ikona1:"envelope",
                        ikona2:"envelope",
                        tekst1:"info.psh@rks-psh.org",
                        tekst2:"info.kpk@rks-psh.org",
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.magazine.title') ? this.$t('menus.kpk.footer.magazine.title') : null,
                        ikona_read:"link",
                        read:this.$te('menus.kpk.footer.magazine.read') ? this.$t('menus.kpk.footer.magazine.read') : null,
                        link:this.$te('menus.kpk.footer.magazine.link') ? this.$t('menus.kpk.footer.magazine.link') : null,
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.social_media.title') ? this.$t('menus.kpk.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('menus.kpk.footer.social_media.link') ? this.$t('menus.kpk.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('menus.kpk.footer.social_media.link2') ? this.$t('menus.kpk.footer.social_media.link2') : null,
                    }
            ],
            pa: [
                    {
                        titulli:this.$te('menus.kpk.footer.address.title') ? this.$t('menus.kpk.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('menus.kpk.footer.address.address_content') ? this.$t('menus.kpk.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.contact.title') ? this.$t('menus.kpk.footer.contact.title') : null,
                        ikona1:"envelope",
                        ikona2:"phone-volume",
                        tekst1:"ZKPSH: +383 (0) 38 200 66920",
                        tekst2:"KPK: +383 (0) 38 200 17 473",
                        tekst3:"+383 (0) 38 200 17 473",
                        tekst3_title:this.$te('menus.kpk.footer.contact.reception') ? this.$t('menus.kpk.footer.contact.reception') : null
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.email.title') ? this.$t('menus.kpk.footer.email.title') : null,
                        ikona1:"envelope",
                        ikona2:"envelope",
                        tekst1:"info.psh@rks-psh.org",
                        tekst2:"prokuroria.apelit@rks-psh.org",
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.magazine.title') ? this.$t('menus.kpk.footer.magazine.title') : null,
                        ikona_read:"link",
                        read:this.$te('menus.kpk.footer.magazine.read') ? this.$t('menus.kpk.footer.magazine.read') : null,
                        link:this.$te('menus.kpk.footer.magazine.link') ? this.$t('menus.kpk.footer.magazine.link') : null,
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.social_media.title') ? this.$t('menus.kpk.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('menus.kpk.footer.social_media.link') ? this.$t('menus.kpk.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('menus.kpk.footer.social_media.link2') ? this.$t('menus.kpk.footer.social_media.link2') : null,
                    }
            ],
            ps: [
                    {
                        titulli:this.$te('menus.ps.footer.address.title') ? this.$t('menus.ps.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('menus.ps.footer.address.address_content') ? this.$t('menus.ps.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('menus.ps.footer.contact.title') ? this.$t('menus.ps.footer.contact.title') : null,
                        ikona1:"phone-volume",
                        tekst1:"+383 (0) 38 200 18 863",
                        tekst1_title:this.$te('menus.kpk.footer.contact.reception') ? this.$t('menus.ps.footer.contact.reception') : null
                    },
                    {
                        titulli:this.$te('menus.ps.footer.email.title') ? this.$t('menus.ps.footer.email.title') : null,
                        ikona1:"envelope",
                        tekst1:"prokuroria.speciale@rks-psh.org"
                    },
                    {
                        titulli:this.$te('menus.ps.footer.magazine.title') ? this.$t('menus.ps.footer.magazine.title') : null,
                        ikona_read:"link",
                        read:this.$te('menus.ps.footer.magazine.read') ? this.$t('menus.ps.footer.magazine.read') : null,
                        link:this.$te('menus.kpk.footer.magazine.link') ? this.$t('menus.ps.footer.magazine.link') : null,
                    },
                    {
                        titulli:this.$te('menus.ps.footer.social_media.title') ? this.$t('menus.ps.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('menus.ps.footer.social_media.link') ? this.$t('menus.ps.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('menus.ps.footer.social_media.link2') ? this.$t('menus.ps.footer.social_media.link2') : null,
                    }
            ],
            zkpsh: [
                    {
                        titulli:this.$te('menus.kpk.footer.address.title') ? this.$t('menus.kpk.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('menus.kpk.footer.address.address_content') ? this.$t('menus.kpk.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.contact.title') ? this.$t('menus.kpk.footer.contact.title') : null,
                        ikona1:"phone-volume",
                        ikona2:"phone-volume",
                        tekst1:"ZKPSH: +383 (0) 38 200 66920",
                        tekst2:"KPK:  +383 (0) 38 200 17 473",
                        tekst3:"+383 (0) 38 200 17 473",
                        tekst3_title:this.$te('menus.kpk.footer.contact.reception') ? this.$t('menus.kpk.footer.contact.reception') : null
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.email.title') ? this.$t('menus.kpk.footer.email.title') : null,
                        ikona1:"envelope",
                        ikona2:"envelope",
                        tekst1:"info.psh@rks-psh.org",
                        tekst2:"info.kpk@rks-psh.org",
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.magazine.title') ? this.$t('menus.kpk.footer.magazine.title') : null,
                        ikona_read:"link",
                        read:this.$te('menus.kpk.footer.magazine.read') ? this.$t('menus.kpk.footer.magazine.read') : null,
                        link:this.$te('menus.kpk.footer.magazine.link') ? this.$t('menus.kpk.footer.magazine.link') : null,
                    },
                    {
                        titulli:this.$te('menus.kpk.footer.social_media.title') ? this.$t('menus.kpk.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('menus.kpk.footer.social_media.link') ? this.$t('menus.kpk.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('menus.kpk.footer.social_media.link2') ? this.$t('menus.kpk.footer.social_media.link2') : null,
                    }
            ],
            pthprishtine: [
                    {
                        titulli:this.$te('menus.pthprishtine.footer.address.title') ? this.$t('menus.pthprishtine.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('menus.pthprishtine.footer.address.address_content') ? this.$t('menus.pthprishtine.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('menus.pthprishtine.footer.contact.title') ? this.$t('menus.pthprishtine.footer.contact.title') : null,
                        ikona1:"phone-volume",
                        tekst1:"+383 (0) 38 200 18 862",
                        tekst1_title:this.$te('menus.pthprishtine.footer.contact.reception') ? this.$t('menus.pthprishtine.footer.contact.reception') : null
                    },
                    {
                        titulli:this.$te('menus.pthprishtine.footer.email.title') ? this.$t('menus.pthprishtine.footer.email.title') : null,
                        ikona1:"envelope",
                        tekst1:"pth.prishtine@rks-psh.org"
                    },
                    {
                        titulli:this.$te('menus.pthprishtine.footer.magazine.title') ? this.$t('menus.pthprishtine.footer.magazine.title') : null,
                        ikona_read:"link",
                        read:this.$te('menus.pthprishtine.footer.magazine.read') ? this.$t('menus.pthprishtine.footer.magazine.read') : null,
                        link:this.$te('menus.pthprishtine.footer.magazine.link') ? this.$t('menus.pthprishtine.footer.magazine.link') : null,
                    },
                    {
                        titulli:this.$te('menus.pthprishtine.footer.social_media.title') ? this.$t('menus.pthprishtine.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('menus.pthprishtine.footer.social_media.link') ? this.$t('menus.pthprishtine.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('menus.pthprishtine.footer.social_media.link2') ? this.$t('menus.pthprishtine.footer.social_media.link2') : null,
                    }
            ],
            pthprizren: [
                    {
                        titulli:this.$te('menus.pthprizren.footer.address.title') ? this.$t('menus.pthprizren.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('menus.pthprizren.footer.address.address_content') ? this.$t('menus.pthprizren.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('menus.pthprizren.footer.contact.title') ? this.$t('menus.pthprizren.footer.contact.title') : null,
                        ikona1:"phone-volume",
                        tekst1:"+383 (0) 38 200 66 429",
                        tekst1_title:this.$te('menus.pthprizren.footer.contact.reception') ? this.$t('menus.pthprizren.footer.contact.reception') : null
                    },
                    {
                        titulli:this.$te('menus.pthprizren.footer.email.title') ? this.$t('menus.pthprizren.footer.email.title') : null,
                        ikona1:"envelope",
                        tekst1:"pth.prizren@rks-psh.org"
                    },
                    {
                        titulli:this.$te('menus.pthprizren.footer.magazine.title') ? this.$t('menus.pthprizren.footer.magazine.title') : null,
                        ikona_read:"link",
                        read:this.$te('menus.pthprizren.footer.magazine.read') ? this.$t('menus.pthprizren.footer.magazine.read') : null,
                        link:this.$te('menus.pthprizren.footer.magazine.link') ? this.$t('menus.pthprizren.footer.magazine.link') : null,
                    },
                    {
                        titulli:this.$te('menus.pthprizren.footer.social_media.title') ? this.$t('menus.pthprizren.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('menus.pthprizren.footer.social_media.link') ? this.$t('menus.pthprizren.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('menus.pthprizren.footer.social_media.link2') ? this.$t('menus.pthprizren.footer.social_media.link2') : null,
                    }
            ],
            pthferizaj: [
                    {
                        titulli:this.$te('menus.pthferizaj.footer.address.title') ? this.$t('menus.pthferizaj.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('menus.pthferizaj.footer.address.address_content') ? this.$t('menus.pthferizaj.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('menus.pthferizaj.footer.contact.title') ? this.$t('menus.pthferizaj.footer.contact.title') : null,
                        ikona1:"phone-volume",
                        tekst1:"+383 (0) 38 200 66 520",
                        tekst1_title:this.$te('menus.pthferizaj.footer.contact.reception') ? this.$t('menus.pthferizaj.footer.contact.reception') : null
                    },
                    {
                        titulli:this.$te('menus.pthferizaj.footer.email.title') ? this.$t('menus.pthferizaj.footer.email.title') : null,
                        ikona1:"envelope",
                        tekst1:"pth.ferizaj@rks-psh.org"
                    },
                    {
                        titulli:this.$te('menus.pthferizaj.footer.magazine.title') ? this.$t('menus.pthferizaj.footer.magazine.title') : null,
                        ikona_read:"link",
                        read:this.$te('menus.pthferizaj.footer.magazine.read') ? this.$t('menus.pthferizaj.footer.magazine.read') : null,
                        link:this.$te('menus.pthferizaj.footer.magazine.link') ? this.$t('menus.pthferizaj.footer.magazine.link') : null,
                    },
                    {
                        titulli:this.$te('menus.pthferizaj.footer.social_media.title') ? this.$t('menus.pthferizaj.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('menus.pthferizaj.footer.social_media.link') ? this.$t('menus.pthferizaj.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('menus.pthferizaj.footer.social_media.link2') ? this.$t('menus.pthferizaj.footer.social_media.link2') : null,
                    }
            ],
            pthpeje: [
                    {
                        titulli:this.$te('menus.pthpeje.footer.address.title') ? this.$t('menus.pthpeje.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('menus.pthpeje.footer.address.address_content') ? this.$t('menus.pthpeje.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('menus.pthpeje.footer.contact.title') ? this.$t('menus.pthpeje.footer.contact.title') : null,
                        ikona1:"envelope",
                        ikona2:"phone-volume",
                        tekst1:"ZKPSH: +383 (0) 38 200 66920",
                        tekst2:"KPK: +383 (0) 38 200 17 473",
                        tekst3:"+383 (0) 38 200 17 473",
                        tekst3_title:this.$te('menus.pthpeje.footer.contact.reception') ? this.$t('menus.pthpeje.footer.contact.reception') : null
                    },
                    {
                        titulli:this.$te('menus.pthpeje.footer.email.title') ? this.$t('menus.pthpeje.footer.email.title') : null,
                        ikona1:"envelope",
                        ikona2:"envelope",
                        tekst1:"info.psh@rks-psh.org",
                        tekst2:"info.kpk@rks-psh.org",
                    },
                    {
                        titulli:this.$te('menus.pthpeje.footer.magazine.title') ? this.$t('menus.pthpeje.footer.magazine.title') : null,
                        ikona_read:"link",
                        read:this.$te('menus.pthpeje.footer.magazine.read') ? this.$t('menus.pthpeje.footer.magazine.read') : null,
                        link:this.$te('menus.pthpeje.footer.magazine.link') ? this.$t('menus.pthpeje.footer.magazine.link') : null,
                    },
                    {
                        titulli:this.$te('menus.pthpeje.footer.social_media.title') ? this.$t('menus.pthpeje.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('menus.pthpeje.footer.social_media.link') ? this.$t('menus.pthpeje.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('menus.pthpeje.footer.social_media.link2') ? this.$t('menus.pthpeje.footer.social_media.link2') : null,
                    }
            ],
            pthmitrovice: [
                    {
                        titulli:this.$te('menus.pthmitrovice.footer.address.title') ? this.$t('menus.pthmitrovice.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('menus.pthmitrovice.footer.address.address_content') ? this.$t('menus.pthmitrovice.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('menus.pthmitrovice.footer.contact.title') ? this.$t('menus.pthmitrovice.footer.contact.title') : null,
                        ikona1:"phone-volume",
                        tekst1:"+383 38 200 662 23",
                        tekst1_title:this.$te('menus.pthmitrovice.footer.contact.reception') ? this.$t('menus.pthmitrovice.footer.contact.reception') : null
                    },
                    {
                        titulli:this.$te('menus.pthmitrovice.footer.email.title') ? this.$t('menus.pthmitrovice.footer.email.title') : null,
                        ikona1:"envelope",
                        tekst1:"pth.mitrovice@rks-psh.org"
                    },
                    {
                        titulli:this.$te('menus.pthmitrovice.footer.magazine.title') ? this.$t('menus.pthmitrovice.footer.magazine.title') : null,
                        ikona_read:"link",
                        read:this.$te('menus.pthmitrovice.footer.magazine.read') ? this.$t('menus.pthmitrovice.footer.magazine.read') : null,
                        link:this.$te('menus.pthmitrovice.footer.magazine.link') ? this.$t('menus.pthmitrovice.footer.magazine.link') : null,
                    },
                    {
                        titulli:this.$te('menus.pthmitrovice.footer.social_media.title') ? this.$t('menus.pthmitrovice.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('menus.pthmitrovice.footer.social_media.link') ? this.$t('menus.pthmitrovice.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('menus.pthmitrovice.footer.social_media.link2') ? this.$t('menus.pthmitrovice.footer.social_media.link2') : null,
                    }
            ],
            pthgjilan: [
                    {
                        titulli:this.$te('menus.pthgjilan.footer.address.title') ? this.$t('menus.pthgjilan.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('menus.pthgjilan.footer.address.address_content') ? this.$t('menus.pthgjilan.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('menus.pthgjilan.footer.contact.title') ? this.$t('menus.pthgjilan.footer.contact.title') : null,
                        ikona1:"phone-volume",
                        tekst1:"+383 38 200 17 890",
                        tekst1_title:this.$te('menus.pthgjilan.footer.contact.reception') ? this.$t('menus.pthgjilan.footer.contact.reception') : null
                    },
                    {
                        titulli:this.$te('menus.pthgjilan.footer.email.title') ? this.$t('menus.pthgjilan.footer.email.title') : null,
                        ikona1:"envelope",
                        tekst1:"pth.gjilan@rks-psh.org"
                    },
                    {
                        titulli:this.$te('menus.pthgjilan.footer.magazine.title') ? this.$t('menus.pthgjilan.footer.magazine.title') : null,
                        ikona_read:"link",
                        read:this.$te('menus.pthgjilan.footer.magazine.read') ? this.$t('menus.pthgjilan.footer.magazine.read') : null,
                        link:this.$te('menus.pthgjilan.footer.magazine.link') ? this.$t('menus.pthgjilan.footer.magazine.link') : null,
                    },
                    {
                        titulli:this.$te('menus.pthgjilan.footer.social_media.title') ? this.$t('menus.pthgjilan.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('menus.pthgjilan.footer.social_media.link') ? this.$t('menus.pthgjilan.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('menus.pthgjilan.footer.social_media.link2') ? this.$t('menus.pthgjilan.footer.social_media.link2') : null,
                    }
            ],
            pthgjakove: [
                    {
                        titulli:this.$te('menus.pthgjakove.footer.address.title') ? this.$t('menus.pthgjakove.footer.address.title') : null,
                        ikona1:"location-dot",
                        tekst1:this.$te('menus.pthgjakove.footer.address.address_content') ? this.$t('menus.pthgjakove.footer.address.address_content') : null,
                    },
                    {
                        titulli:this.$te('menus.pthgjakove.footer.contact.title') ? this.$t('menus.pthgjakove.footer.contact.title') : null,
                        ikona1:"envelope",
                        ikona2:"phone-volume",
                        tekst1:"+383 (0) 38 200 66 723",
                        tekst2:"+383 (0) 200 667 18",
                        tekst3_title:this.$te('menus.pthgjakove.footer.contact.reception') ? this.$t('menus.pthgjakove.footer.contact.reception') : null
                    },
                    {
                        titulli:this.$te('menus.pthgjakove.footer.email.title') ? this.$t('menus.pthgjakove.footer.email.title') : null,
                        ikona1:"envelope",
                        tekst1:"pth.gjakove@rks-psh.org"
                    },
                    {
                        titulli:this.$te('menus.pthgjakove.footer.magazine.title') ? this.$t('menus.pthgjakove.footer.magazine.title') : null,
                        ikona_read:"link",
                        read:this.$te('menus.pthgjakove.footer.magazine.read') ? this.$t('menus.pthgjakove.footer.magazine.read') : null,
                        link:this.$te('menus.pthgjakove.footer.magazine.link') ? this.$t('menus.pthgjakove.footer.magazine.link') : null,
                    },
                    {
                        titulli:this.$te('menus.pthgjakove.footer.social_media.title') ? this.$t('menus.pthgjakove.footer.social_media.title') : null,
                        ikona1:"facebook",
                        ikona2:"youtube",
                        link:this.$te('menus.pthgjakove.footer.social_media.link') ? this.$t('menus.pthgjakove.footer.social_media.link') : null,
                        read1:"Facebook",
                        read2:"Youtube",
                        link2:this.$te('menus.pthgjakove.footer.social_media.link2') ? this.$t('menus.pthgjakove.footer.social_media.link2') : null,
                    }
            ]
        }

      return allData[sub] || allData.default
    }

    },
    mounted() {
        this.getSubdomain();
        this.data = this.getDataForSubdomain(this.subdomain);
    },

}
</script>
<style scoped>
 
</style>